import { useDebounceEffect } from 'ahooks'
import { useState } from 'react'
function useDocumentSize() {
  const [size, setSize] = useState<{ w: number; h: number }>({
    w: document.documentElement.clientWidth,
    h: document.documentElement.clientHeight
  })

  const onChangeSize = () => {
    setSize({
      w: document.documentElement.clientWidth,
      h: document.documentElement.clientHeight
    })
  }

  useDebounceEffect(
    () => {
      window.addEventListener('resize', onChangeSize)
      return () => {
        window.removeEventListener('resize', onChangeSize)
      }
    },
    [],
    { wait: 500 }
  )

  return { size }
}

export default useDocumentSize
